import { render } from "./Join.vue?vue&type=template&id=642a2c52&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import "./Join.vue?vue&type=style&index=0&id=642a2c52&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642a2c52"]])

export default __exports__